import env from '@/utils/env';
import getSearchObj from '@/utils/getSearchObj';
import { PLATFORM_TYPE } from '@/utils/uploadImg.js';
import BrowserCallNative from './BrowserCallNative.js';
import alipay from '../platformUtils/alipay';

class AlipayCallNative extends BrowserCallNative {
  static lastTime = '';

  static scanQRCode() {
    return alipay.scanQRCode();
  }

  static vibrate() {
    return alipay.vibrate();
  }

  static setPageTitle(options) {
    super.setPageTitle(options);
    return alipay.setTitle(options);
  }

  static async getTokenAndKey() {
    const curTime = (new Date()).getTime();
    if (curTime === this.lastTime) {
      this.lastTime = curTime - (24 * 3600 * 1000);
    } else {
      this.lastTime = curTime;
    }
    let res = {};
    if (env.isAliMP) {
      res = await alipay.mpPostMessage({
        command: 'getUserInfo',
        callbackId: `getUserInfo${this.lastTime}`,
        dataArray: [{}],
      });
    } else if (env.isAlipayClient) {
      return getSearchObj() || {};
    }
    return res;
  }

  static hideShareMenu() {
    return alipay.mpHideShareMenu();
  }

  static navigateTo(url) {
    return alipay.mpNavigateTo(url);
  }

  static savePicture(data) {
    return alipay.mpSaveImage(data);
  }

  static makePhoneCall(tel) {
    return alipay.makePhoneCall(tel);
  }

  static closeWebView() {
    return alipay.closeWebView();
  }

  static jumpTo(url) {
    return alipay.mpPostMessage({
      command: 'jumpTo',
      callbackId: `jumpTo${this.lastTime}`,
      dataArray: [url],
    });
  }

  static callNative(name, data) {
    if (!this[name]) {
      return Promise.reject(new Error(`${name}功能在支付宝中暂时无法使用`));
    }
    return this[name](data);
  }

  static callphotograph(onlyUseCamera) {
    return new Promise((resolve, reject) => {
      alipay.loadMPJSSDKScript().then((my) => {
        my.chooseImage({
          count: 1,
          sourceType: onlyUseCamera ? ['camera'] : ['album', 'camera'],
          sizeType: ['compressed'],
          success: (res) => {
            if (!res.apFilePaths[0]) {
              // TIANQI_UBT.customEvent({
              //   eventId: 'alipay_callphotograph_error',
              //   categoryId: 'hitch',
              // });
            }
            resolve(res.apFilePaths[0]);
          },
          fail: (e) => {
            if (+((e || {}).error !== 11)) {
              // 用户取消
              reject(e);
            }
          },
        });
      }).catch((e) => reject(e));
    });
  }

  static async chooseImageAndUploadImage(Params) {
    let beforeUpload;
    let afterUpload;
    if (Params) {
      ({
        beforeUpload,
        afterUpload,
      } = Params);
    }
    const onlyUseCamera = !!(Params && Params.onlyUseCamera);
    const apFilePath = await this.callphotograph(onlyUseCamera);
    if (beforeUpload) {
      beforeUpload();
    }
    try {
      const res = await alipay.mpPostMessage({
        command: 'uploadFile',
        callbackId: 'uploadFile',
        dataArray: [
          apFilePath,
          {
            image: 40,
            type: PLATFORM_TYPE.ALI_MP,
          },
        ],
      });
      if (afterUpload) {
        afterUpload();
      }
      return res ? res.url : '';
    } catch (error) {
      if (afterUpload) {
        afterUpload();
      }
      return '';
    }
  }
}
AlipayCallNative.lastTime = '';
export default AlipayCallNative;
